import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

export interface SpecialPlateInfo {
  title: string;
  description: string;
  icon: string;
}

@Component({
  selector: 'pla-special-plate-info',
  templateUrl: './special-plate-info.component.html',
  styleUrls: ['./special-plate-info.component.scss'],
})
export class SpecialPlateInfoComponent implements OnChanges {
  @Input() public plateCategory: string;

  public info: SpecialPlateInfo | null = null;

  private readonly categoryInfo: Record<string, SpecialPlateInfo> = {
    export: {
      title: 'Export Plate',
      description:
        'This is an XP-series export registration, used for vehicles sold new outside the UK. ' +
        'The "XP" prefix identifies it as an export plate — it does not correspond to a DVLA issue region. ' +
        'Export plates carry a valid age identifier and may be re-registered in the UK.',
      icon: 'flight_takeoff',
    },
    q_plate: {
      title: 'Q Registration',
      description:
        'Q plates are issued by the DVLA when the age or identity of a vehicle cannot be determined — ' +
        'for example, kit cars, severely modified vehicles, or imports with uncertain history. ' +
        'The Q prefix means no issue date can be confirmed.',
      icon: 'help_outline',
    },
    diplomatic: {
      title: 'Diplomatic Plate',
      description:
        'Diplomatic registrations (format NNN D/X NNN) are issued to foreign diplomats and embassy staff ' +
        'in the UK under the Vienna Convention. They are not available for private purchase.',
      icon: 'account_balance',
    },
    military: {
      title: 'Military Registration',
      description:
        'Military registrations are issued by the Ministry of Defence for service vehicles. ' +
        'They follow a distinct format and are not available through the DVLA for private transfer.',
      icon: 'military_tech',
    },
    northern_ireland: {
      title: 'Northern Ireland',
      description:
        'Northern Ireland registrations use a distinct format with area codes such as those ending in Z ' +
        'or containing the letter I. These plates are issued by the DVA (Driver and Vehicle Agency) ' +
        'in Northern Ireland rather than the DVLA in Swansea.',
      icon: 'location_on',
    },
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['plateCategory']) {
      this.info = this.categoryInfo[this.plateCategory] ?? null;
    }
  }
}
